<template>
  <v-container v-if="!overlayed"
               fluid>
    <v-alert type="info"
             icon="square_foot"
             max-width="600"
             class="mx-auto mt-5 material-icons-outlined"
             dark
             prominent>
      <h2 v-text="headertext" />
      <div v-html="bodytext" />
    </v-alert>
  </v-container>
  <v-overlay v-else
             :absolute="true"
             style="cursor: pointer;">
    <v-alert type="info"
             icon="square_foot"
             max-width="600"
             class="mx-auto mt-5 material-icons-outlined"
             dark
             prominent>
      <h2 v-text="headertext" />
      <div v-html="bodytext" />
    </v-alert>
  </v-overlay>
</template>

<script>
export default {
  props: {
    overlayed: Boolean,
    section: Boolean,
  },

  data() {
    return {
      path: this.$route.name,
    };
  },

  computed: {
    headertext() {
      return this.$t("servicesystem.pages.endpoints.planned_construction_title");
    },
    bodytext() {
      return this.$t("servicesystem.pages.endpoints.planned_construction_body", {
        pkey: this.section ? this.$t('servicesystem.common_objects.commonterms.section') : this.$route.name,
      });
    },
  },
};
</script>